(function () {
  const API_URL = 'https://api-us.ugnas.com/api/system/v3/sa/apk';
  const androidtvGoogleLink = 'https://play.google.com/store/apps/details?id=com.ugreen.nasprotv';

  const tipData = {
    version: 'Version',
    update: 'Update',
    size: 'Size',
    download: 'Download',
    androidtvGoogleContent: 'Search and download in Google Play',
  };

  function returnVerDivFn(data, downloadName) {
    let tipsdiv = `<p><span>${data.scopeApplication}</span></p>`;
    if (data.clientBit == 3) {
      tipsdiv = `<p><span>${data.armScope}</span></p>`;
    }

    return `<div class="ug-download-itempr relative">
      <div class="ug-downloads-getVerifyFn ug-downloads-button" data-pkgUrl="${data.pkgUrl}" data-appNo="${data.appNo}">${downloadName}</div>
      <div class="Version_popup bg-[#fff] px-[16px] py-[16px] min-w-[240px]">
        ${tipsdiv}
        <p><span>${tipData.version}: ${data.verName}</span></p>
        <p class="whitespace-nowrap">${tipData.update}: ${data.showTime}</p>
        <p class="whitespace-nowrap">${tipData.size}: ${data.showSize}M</p>
      </div>
    </div>`;
  }

  function returnLinkDivFn(url, downloadName) {
    return `<div class="ug-download-itempr relative">
      <a class="ug-downloads-button" href="${url}" target="_blank">${downloadName}</a>
    </div>`;
  }

  function appendHtml(selector, html) {
    const container = document.querySelector(selector);
    if (container && html) {
      container.insertAdjacentHTML('beforeend', html);
    }
  }

  function processAppData(appSoftVers) {
    const dataDivList = { windows: '', mac: '', tvClient: '', androidtvClient: '' };

    appSoftVers.forEach((v) => {
      const timestamp = new Date(v.utime);
      const timeMonth = timestamp.getMonth() + 1;
      v.showTime = timestamp.getDate() + '/' + timeMonth + '/' + timestamp.getFullYear();
      v.showSize = (v.size / 1024).toFixed(2);

      if (v.appNo === 'com.ugreenNasPro.mac') {
        const downloadName = dataDivList.mac
          ? v.clientBit == 0
            ? 'Download Intel x86'
            : v.clientBit == 3
              ? 'Download Apple M'
              : tipData.download
          : v.clientBit == 0
            ? 'Intel x86'
            : v.clientBit == 3
              ? 'Apple M'
              : tipData.download;
        dataDivList.mac += returnVerDivFn(v, downloadName);
      } else if (v.appNo === 'com.ugreenNasPro.win') {
        const downloadName = dataDivList.windows
          ? v.clientBit == 1
            ? 'Download 32-bit version'
            : v.clientBit == 2
              ? 'Download 64-bit version'
              : tipData.download
          : v.clientBit == 1
            ? 'windows 32-bit'
            : v.clientBit == 2
              ? 'windows 64-bit'
              : tipData.download;
        dataDivList.windows += returnVerDivFn(v, downloadName);
      } else if (v.appNo === 'com.ugreen.tvpro.tvos') {
        const downloadName = dataDivList.tvClient
          ? v.clientBit == 1
            ? 'Download 32-bit version'
            : v.clientBit == 2
              ? 'Download 64-bit version'
              : tipData.download
          : v.clientBit == 1
            ? 'TV Client 32-bit'
            : v.clientBit == 2
              ? 'TV Client 64-bit'
              : tipData.download;
        dataDivList.tvClient += returnVerDivFn(v, downloadName);
      } else if (v.appNo === 'com.ugreen.nasprotv.int.official.android') {
        const downloadName = dataDivList.androidtvClient
          ? v.clientBit == 1
            ? 'Download 32-bit version'
            : v.clientBit == 2
              ? 'Download 64-bit version'
              : tipData.download
          : v.clientBit == 1
            ? 'TV Client(Android) 32-bit'
            : v.clientBit == 2
              ? 'TV Client(Android) 64-bit'
              : tipData.download;
        dataDivList.androidtvClient += returnVerDivFn(v, downloadName);
      }
    });

    if (dataDivList.tvClient) {
      dataDivList.androidtvClient += returnLinkDivFn(androidtvGoogleLink, tipData.androidtvGoogleContent);
    }

    appendHtml('.download_box .win_download .ug-download-itemab', dataDivList.windows);
    appendHtml('.download_box .mac_download .ug-download-itemab', dataDivList.mac);
    appendHtml('.download_box .appletv_download .ug-download-itemab', dataDivList.tvClient);
    appendHtml('.download_box .androidtv_download .ug-download-itemab', dataDivList.androidtvClient);
  }

  function init() {
    if (!document.querySelector('.download_box')) return;

    fetch(API_URL, {
      method: 'GET',
      headers: {
        'Accept-Language': 'en-US',
      },
    })
      .then((response) => response.json())
      .then((data) => {
        if (data?.data?.appSoftVers?.length) {
          processAppData(data.data.appSoftVers);
        }
      })
      .catch((error) => {
        console.error('ug-app-download-box:', error);
      });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
